import { FeatureDTO } from "./FeatureDTO";

export class SubPlatformFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
